module.exports = __webpack_public_path__ + "608529dadc082a8c8baec866f5727427.svg";